import { render, staticRenderFns } from "./WhatsappContact.vue?vue&type=template&id=ff2322d4&scoped=true&"
import script from "./WhatsappContact.vue?vue&type=script&lang=js&"
export * from "./WhatsappContact.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappContact.vue?vue&type=style&index=0&id=ff2322d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2322d4",
  null
  
)

export default component.exports